import { VERIFIED_INSURERS } from "./verifiedInsurers";
import { openAffiliatePartner } from "./partnerRouting";

// Iter-462 — Insurify partner landing used for "Learn more" on carriers
// outside the Insurify network (e.g. State Farm, Nationwide).
export const INSURIFY_LEARN_MORE_URL =
  "https://insurify.com/start/auto/partner/carsavr/?utm_source=carsavr&utm_medium=auto";

const NETWORK = new Set(VERIFIED_INSURERS.map((i) => i.slug));

// Returns null for non-carrier rows (loans, warranty, marketplaces).
export function insuranceCtaFor(rate) {
  if (rate?.category !== "insurance" || rate.provider_type === "marketplace") return null;
  if (!rate.slug?.endsWith("-insurance") || rate.slug === "insurify-insurance") return null;
  const inNetwork = NETWORK.has(rate.slug.replace(/-insurance$/, ""));
  return inNetwork
    ? { label: "Compare quotes", offNetwork: false }
    : {
        label: "Learn more",
        offNetwork: true,
        open: (sourcePage) =>
          openAffiliatePartner({
            url: INSURIFY_LEARN_MORE_URL,
            partnerName: "Insurify",
            source: `rate-learn-more-${rate.slug}${sourcePage ? `:${sourcePage}` : ""}`,
            category: "insurance",
          }),
      };
}
